<ng-container *transloco="let t;">
    <div class="admin-layout">
        <div class="app-login-body">
            <img class="login-screen-main-img" src="../../assets/app-assets/images/general/login-screen-main-img.svg" alt="">
            <img class="login-screen-pattren-img" src="../../assets/app-assets/images/general/login-pattern.svg" alt="">
            
            <div class="login-header d-flex justify-content-between">
                <div>
                    <div class="logo">
                        <img src="../../assets/app-assets/images/logo/logo-yellow.svg" alt="">
                    </div>
                    <p class="text clr-white fs-12">Customizable connectivity solutions that<br>matter to your business.</p>
                </div>
                <div class="login-page-lang">
                    <app-language-changer />
                </div>
            </div>
           <div class="row">
               <div class="col-md-6">
               </div>
               <div class="col-md-6">
                <div class="card login-form" *ngIf="!showChangePassword">
                    <div class="card-body">
                       <div class="text-center mb-4">
                        <p class="title clr-primary xl font-m">{{t('forgotYourPassword')}}</p>
                        <p class="text">{{t('enterInfoToResetPassword')}}</p>
                       </div>
                       <form [formGroup]="loginForm" (ngSubmit)="submit()" class="form flex flex-column" novalidate>
                        <div class="form-container">
                            <div class="field">
                                <input formControlName="email" type="text" autocomplete="off" pInputText
                                    [placeholder]="t('yourEmailAddress')">
                            </div>
                        </div>
                        <div class="button-container">
                            <button type="submit" class="app-button btn-primary w-100" label="Login"
                                [disabled]="!loginForm.valid || showSubmitButtonLoader">{{t('sendEmail')}}
                                <span style="margin-left: 65%; position: absolute;"><i *ngIf="showSubmitButtonLoader"
                                        style="float: right;" class="pi pi-spin pi-spinner"></i></span>
                            </button>
                        </div>
                    </form>
                    </div>
                </div>
                <div class="card login-form" *ngIf="showChangePassword">
                    <div class="card-body">
                       <div class="text-center mb-4">
                        <p class="title clr-blue xl font-m mb-3">Changement de mot de passe</p>
                        <p class="text clr-light2 ">Veuillez choisir votre nouveau mot de passe avant d’accéder à votre espace personnel</p>
                       </div>
                       <form [formGroup]="forgotForm" (ngSubmit)="forgotSubmit()" class="form flex flex-column" novalidate>
                        <div class="form-container">
                            
                            <div class="field">
                                <label>Créez votre nouveau mot de passe</label>
                                <span class="p-input-icon-right">
                                    <input formControlName="password" [type]="showPassword ? 'text' : 'password'"
                                        autocomplete="off" pInputText placeholder="Nouveau mot de passe">
                                    <i *ngIf="showPassword" class="pi pi-eye" (click)="showHidePassword()"></i>
                                    <i *ngIf="!showPassword" class="pi pi-eye-slash" (click)="showHidePassword()"></i>
                                </span>
        
                            </div>
                            <div class="field">
                                <!-- <input formControlName="confirmPassword" type="password" autocomplete="off" pInputText
                                    placeholder="Confirmer nouveau mot de passe"> -->
        
                                <span class="p-input-icon-right">
                                    <input formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
                                        autocomplete="off" pInputText placeholder="Confirmer nouveau mot de passe">
                                    <i *ngIf="showConfirmPassword" class="pi pi-eye" (click)="showHideConfirmPassword()"></i>
                                    <i *ngIf="!showConfirmPassword" class="pi pi-eye-slash"
                                        (click)="showHideConfirmPassword()"></i>
                                </span>
                            </div>
        
                            <div class="d-flex flex-column gap-1 mb-3">
                                <p class="text">Fiabilité du mot de passe : Bonne</p>
                                <p class="text clr-light2 fs-12">Entre 8 et 16 caractères</p>
                                <p class="text clr-light2 fs-12">Une majuscule et une minuscule</p>
                                <p class="text clr-light2 fs-12">Un chiffre</p>
                                <p class="text clr-light2 fs-12">Caractères spéciaux (%#:$*)</p>
                            </div>
                        </div>
                        <div class="button-container">
                            <button type="submit" class="app-button btn-primary w-100" label="Forgot"
                                [disabled]="!forgotForm.valid">Réinitialiser et se connecter
                                <span style="margin-left: 65%; position: absolute;"><i *ngIf="showForgotSubmitButtonLoader"
                                        style="float: right;" class="pi pi-spin pi-spinner"></i></span>
                            </button>
                        </div>
                    </form>
                    </div>
                </div>
               </div>
           </div>
           <div class="login-footer">
               <p class="text text-white fs-12">{{latestYear}} {{t('footerText')}}</p>
           </div>
        </div>
    </div>
</ng-container>
